export const apple_store_link = 'https://apps.apple.com/kr/app/zigzag/id976131101';
export const play_store_link = 'https://play.google.com/store/apps/details?id=com.croquis.zigzag';
